module.exports = __webpack_public_path__ + "img/n6-bg4.7be4261f.png";